import React, { useState , useCallback} from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import { ChevronLeft, ChevronRight} from "@mui/icons-material";
import ToggleOnIcon  from "@mui/icons-material/ToggleOn";
import ToggleOffIcon   from "@mui/icons-material/ToggleOff";
import { useMap } from "@vis.gl/react-google-maps";
import useStyles from "./style";

const DriverList = ({allDrivers , availabledrivers ,setSelectedDriver ,setMapCenter , userType , subcmpnyName }) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const map = useMap();
 // Toggle function for sliding


  // //console.log("all drivers list from panel--->",allDrivers);
  // //console.log('availabledrivers from panel--->',availabledrivers);
  const driverSource =
    availabledrivers && availabledrivers.length > 0 ? availabledrivers : allDrivers;
    // Check if there are no available drivers
    const isNoDriversFound = driverSource.length === 1 && driverSource[0].no_drivers;
  // Filter drivers based on search input
  const filteredDrivers = !isNoDriversFound
  ? driverSource.filter((driver) => {
    if (userType === "SUB COMPANY" && subcmpnyName) {
      if (driver?.driver_ride_details?.sub_companyName !== subcmpnyName) {
        return false;
      }
    }
      return (
        driver.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        driver.lastName.toLowerCase().includes(searchTerm.toLowerCase())
      );
   }): [];

  const handleSelectdriver = useCallback((row) => {
    //console.log('the selected driver-->',row);
    setSelectedDriver(row)
    const newLatLng = { lat: Number(row.driver_ride_details.latitude), lng: Number(row.driver_ride_details.longitude) };
    setMapCenter((prevCenter) => (
      prevCenter.lat !== newLatLng.lat || prevCenter.lng !== newLatLng.lng ? newLatLng : prevCenter
    ));
  
    // Smoothly 
      map.panTo(newLatLng);
    
    })

  return (

    <Box >
    {/* Chevron Button */}
    <IconButton className={classes.chevronbutton}
      onClick={() => setIsOpen(!isOpen)}
      sx={{
        left: isOpen ? 331 : 0,
        boxShadow: 3, // Adjust based on card width
      }}
    >
      {isOpen ? <ChevronLeft /> : <ChevronRight />}
    </IconButton>

  <Card className={classes.driverdlistbox} style={{
          left: isOpen ? 0 : "-100%", // Moves the card in and out
          transition: "left 0.3s ease-in-out", // Smooth animation
        }}>
   

  {/* Search Input */}
  <Box p={2}>
  <TextField
  fullWidth
  placeholder="Search for barbaers"
  size="small"
  variant="outlined"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
  />
  </Box>

  {/* Table */}
  <TableContainer>
  <Table>
  <TableHead sx={{ background: "#000" }}>
    <TableRow>
      <TableCell sx={{ color: "#fff" }}>Barber Info</TableCell>
      <TableCell sx={{ color: "#fff", textAlign: "center" }}>Device</TableCell>
      <TableCell sx={{ color: "#fff", textAlign: "center" }}>Status</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
  {isNoDriversFound ? (
        <TableRow>
          <TableCell colSpan={3} align="center">
            {driverSource[0].no_drivers}
          </TableCell>
        </TableRow>
      ) : 
    filteredDrivers.length > 0 ? (
      filteredDrivers.map((driver, index) => (
<TableRow key={index} hover onClick={() => handleSelectdriver(driver)} sx={{ cursor: "pointer"}}>
  {/* Driver Info */}
  <TableCell>
    <Box display="flex" alignItems="center">
      <Avatar src={driver?.image} sx={{ width: 40, height: 40, mr: 1 }} />
      <Box>
        <Typography variant="body1">{driver?.firstName} {driver?.lastName}</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ display: "flex" }} >
          {driver?.driver_ride_details?.service_details?.serviceName} - 
          {driver?.driver_ride_details?.service_details?.serviceImage && (
    <Box
      component="img"
      src={driver.driver_ride_details.service_details.serviceImage}
      alt="Service Icon"
      sx={{ width: 35, height: 35, ml: 1 }}
    />)}
        </Typography>
      </Box>
    </Box>
  </TableCell>

  {/* Device */}
  <TableCell align="center">
    {driver.device_type === "android" ? <AndroidIcon color="success" /> : <AppleIcon color="action" />}
  </TableCell>

  {/* Status */}
  <TableCell align="center">
  {driver?.driver_ride_details?.rideStatus === "ACTIVE" ? (
    <ToggleOnIcon sx={{ color: "green" }} />
  ) : driver?.driver_ride_details?.rideStatus === "RIDING" ? (
    <ToggleOnIcon sx={{ color: "blue" }} />
  ) : (
    <ToggleOffIcon  sx={{ color: "red" }} />
  )}
</TableCell>
</TableRow>
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={3} align="center">
          No Barbers found
        </TableCell>
      </TableRow>
    )}
  </TableBody>
  </Table>
  </TableContainer>
  </Card>
  </Box>
  );
};

export default DriverList;
